export default __webpack_public_path__ + "static/triwest-07c43cc0d920d32135c9b9eba891602d.svg";